// extracted by mini-css-extract-plugin
export default {"wrapper":"changelog_wrapper__okbOM","title":"changelog_title__6rWmm","info":"changelog_info__kGUei","wrapperRealease":"changelog_wrapperRealease__ekfzG"};